export default "<div id=\"wrapper_company_auth\">\n    <div class=\"company-auth-content\">\n        <router-outlet></router-outlet>\n    </div>\n</div>\n\n"